<template>
  <summary-count
    title="Delayed Start"
    :is-loading="isLoading"
    :count="count"
    :count-class="'tw-text-red-500'"
    :caption="'Needs Follow-Up'"
    :caption-class="'tw-text-red-500'"
    :clickable="true"
    @cardClicked="gotoPrescriptions"
  />
</template>

<script>
import SummaryCount from "@/views/business/dashboard/components/SummaryCount.vue";

export default {
  name: "DelayedStart",
  components: {
    SummaryCount,
  },
  props: {
    summaryData: {
      type: Object,
      default: () => ({}),
    },
    isSummaryLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    count() {
      return this.summaryData.delayedStart || 0;
    },
    isLoading() {
      return this.isSummaryLoading;
    },
  },
  methods: {
    gotoPrescriptions() {
      this.$router.push({
        path: `/businesses/${this.$route.params.businessId}/prescriptions`,
        query: { status: "delayed_entry" },
      });
    },
  },
};
</script>
